// extracted by mini-css-extract-plugin
export default {"text":"normal_text__rvWHq","currency":"normal_currency__p5Llw"};